<template>
  <section
    ref="section"
    class="two-box-module-component"
    :class="{
      'mobile-reversed': data.mobile.reverse,
    }"
    :style="{
      '--top-box-mob-h': `${data.mobile.mobile_t_h}px`,
      '--bot-box-mob-h': `${data.mobile.mobile_b_h}px`,
      '--sphere-color': `${data.line_sph.sph_color}`,
      '--vfx-h': `calc(100% + ${getVfxHeightOffset()}px)`,

      // '--total-mob-h': `${parseInt(data.boxes[1].mobile_h) + parseInt(data.boxes[0].mobile_h)}px`,
      // '--half-mob-h': `${(parseInt(data.boxes[1].mobile_h) + parseInt(data.boxes[0].mobile_h)) / 2}px`,
    }">
    <div class="bg-imgs">
      <div
        v-for="(box, idx) in data.boxes"
        :key="`img-${idx}`"
        class="bg-img"
        :style="{ backgroundImage: `url('${box.img.url}')` }">
        <div
          v-if="box.nums_vfx"
          class="nums-vfx">
          <NumsVfx :color="box.num_color" />
        </div>
      </div>
    </div>
    <div class="vfx-container">
      <div
        class="vfx inner-container"
        :class="{
          'stacking-top': data.stacking.top_stack,
          'stacking-bottom': data.stacking.bottom_stack,
        }">
        <div
          class="line-w-circle"
          :class="`end-${data.mobile.end_line}`"
          :style="{
            transform:
              data.line_sph.line_offset != 0 && device === 'desktop'
                ? `translateX(${data.line_sph.line_offset}%)`
                : null,
          }">
          <div
            ref="line"
            class="line"
            :class="`line-${linePos()} line-${data.line_sph.line_color}`"></div>
          <div
            class="sphere-rails"
            :class="`line-${linePos()}`">
            <div
              ref="sphere"
              class="sphere" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="component-content inner-container"
      :class="[
        `padding-line-${linePos()}`,
        {
          'stacking-top': data.stacking.top_stack,
          'stacking-bottom': data.stacking.bottom_stack,
        },
      ]">
      <div class="boxes">
        <Button
          v-if="device === 'desktop'"
          class="floating-cta"
          :class="[`cta-${data.cta_group.position}`]"
          :text="data.cta_group.cta.title"
          :url="data.cta_group.cta.url"
          :target="data.cta_group.cta.target" />
        <Button
          v-else
          class="floating-cta"
          :class="`cta-${data.mobile.position}`"
          :text="data.cta_group.cta.title"
          :url="data.cta_group.cta.url"
          :target="data.cta_group.cta.target" />
        <div
          v-for="(box, idx) in data.boxes"
          :key="`box-${idx}`"
          :src="box.img.url"
          class="box-item">
          <h2
            v-if="box.content.title"
            class="box-item-title"
            v-html="box.content.title" />
          <div
            v-if="box.content.text"
            class="box-item-text"
            v-html="box.content.text" />
          <Button
            v-if="renderBtn(idx)"
            class="cta-container"
            :class="`cta-${data.cta_group.position}`"
            :text="data.cta_group.cta.title"
            :url="data.cta_group.cta.url"
            :target="data.cta_group.cta.target" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "TwoBoxComponent",
    "CLASSNAME": "two-box-module-component",
    "URL": "http://lifemine.local/templates/"
   }
  #ENDMETA */

/*
 *   Insert your logic here
 */
import { onBeforeUnmount, onMounted, ref } from 'vue'
import Button from '@/components/utility/ButtonGlobal.vue'
import NumsVfx from '@/components/utility/NumsVfxComponent.vue'
import useUtils from '@/composables/useUtils'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const { device, genUUID } = useUtils()
const props = defineProps(['data'])
const animID = ref(genUUID())
const sphere = ref()
const line = ref()
const section = ref()

const renderBtn = (idx) => {
  if (device.value === 'desktop') {
    if (
      (idx === 0 && props.data.cta_group.position === 'l') ||
      (idx === 1 && props.data.cta_group.position === 'r')
    ) {
      return true
    }
  } else {
    if (
      (idx === 0 && props.data.mobile.position === 'l') ||
      (idx === 1 && props.data.mobile.position === 'r')
    ) {
      return true
    }
  }
  return false
}

const linePos = () => {
  if (device.value === 'desktop') {
    return props.data.line_sph.line_position
  } else {
    return props.data.mobile.line_position
  }
}

const sphereAnimIn = () => {
  gsap.to(sphere.value, {
    y: -100,
    ease: 'power1.out',
    scrollTrigger: {
      trigger: section.value,
      scrub: true,
      start: 'top center+=20%',
      end: 'top+=40% center',
      // markers: true,
      id: animID.value,
    },
  })
}

const sphereAnimEnd = () => {
  gsap.fromTo(
    sphere.value,
    {
      y: -50,
    },
    {
      y: 0,
      ease: 'power1.in',
      scrollTrigger: {
        trigger: section.value,
        scrub: true,
        start: 'top-=10% center',
        end: 'top+=10% top+=30%',
        // markers: true,
        id: animID.value,
      },
    }
  )
}

const lineAnim = (end) => {
  gsap.fromTo(
    line.value,
    {
      height: '0%',
    },
    {
      height: `${end ? '20' : '100'}%`,
      // ease: 'power1.out',
      scrollTrigger: {
        trigger: section.value,
        scrub: true,

        start: 'top+=100px center+=20%',
        end: `${end ? 'top+=300px' : 'bottom+=100px'} center+=20%`,
        // markers: true,
        id: animID.value,
      },
    }
  )
}

const getVfxHeightOffset = () => {
  let offset = 0
  if (!props.data.stacking.top_stack) {
    offset += 40
  }
  if (!props.data.stacking.bottom_stack) {
    offset += 40
  }
  return offset
}

onMounted(async () => {
  if (props.data.mobile.end_line && device.value !== 'desktop') {
    sphereAnimEnd()
    lineAnim(true)
  } else {
    lineAnim()
    sphereAnimIn()
  }
})

onBeforeUnmount(() => {
  ScrollTrigger.getById(animID.value)?.kill()
})
</script>

<style lang="scss">
.two-box-module-component {
  @apply relative;

  .bg-imgs {
    @apply absolute w-full flex flex-col lg:flex-row lg:h-[698px];

    .bg-img {
      @apply w-full bg-cover overflow-hidden;

      .nums-vfx {
        @apply h-full w-full;
      }
    }

    .bg-img:first-child {
      @apply h-[--top-box-mob-h] lg:h-full;
    }

    .bg-img:nth-child(2) {
      @apply h-[--bot-box-mob-h] lg:h-full;
    }
  }

  .vfx-container {
    @apply absolute w-full h-full;

    .vfx {
      @apply -top-10 h-[var(--vfx-h)] w-full;

      &.stacking-top:not(.stacking-bottom) {
        @apply top-0;
      }

      &.stacking-top.stacking-bottom {
        @apply top-0;
      }

      .line-w-circle {
        @apply relative h-full w-full;

        .line,
        .sphere-rails {
          @apply absolute top-0 w-[1px] h-full flex items-center justify-center overflow-visible;

          &-l {
            @apply left-0;
          }

          &-r {
            @apply right-0;
          }

          &-blue {
            @apply bg-lm_lavender;
          }

          &-blue_orange {
            background: linear-gradient(
              171deg,
              rgba(243, 240, 237, 1) 0%,
              rgba(153, 180, 255, 1) 18%,
              rgba(111, 207, 215, 1) 39%,
              rgba(255, 173, 57, 1) 100%
            );
          }

          &-orange {
            @apply bg-lm_yellow;
          }

          .sphere {
            @apply translate-y-[-200px] min-w-[30px] min-h-[30px] rounded-full [background:var(--sphere-color)] blur-[2px];
            box-shadow: 0 0 20px var(--sphere-color);
          }
        }

        // .sphere-rails {
        //   @apply absolute top-0 w-[1px] h-full flex items-center justify-center overflow-visible;

        // }

        &.end-true {
          .line,
          .sphere-rails {
            @apply h-[20%] items-end lg:h-full lg:items-center;

            .sphere {
              @apply translate-y-0 lg:translate-y-[-200px];
            }
          }
        }
      }
    }
  }

  .component-content {
    @apply my-10 lg:h-[698px];

    &.stacking-top {
      @apply mt-0;
    }

    &.stacking-bottom {
      @apply mb-0;
    }

    &.padding-line-l {
      @apply pl-[58px] pr-[27px] lg:px-14;
    }

    &.padding-line-r {
      @apply pl-[25px] pr-[35px] lg:px-14;
    }

    .boxes {
      // remove the translate, this just for now
      @apply relative flex flex-col lg:flex-row lg:h-full lg:translate-x-[17px] lg:px-[33px];

      .floating-cta {
        @apply absolute;

        &.cta-c {
          @apply top-[calc(var(--top-box-mob-h)_-_29px)] left-2/4 -translate-x-2/4 translate-y-0 lg:top-auto lg:bottom-[155px];
        }

        &.cta-l {
          @apply hidden;
        }

        &.cta-r {
          @apply hidden;
        }
      }

      .cta-container {
        @apply mt-9 lg:mt-[40px];
      }

      .box-item {
        @apply flex flex-col justify-center py-[42px] gap-5 lg:justify-start lg:gap-[34px] lg:w-1/2 lg:py-[155px] lg:h-full;

        &-title {
          @apply heading-2 text-white;
        }

        &-text {
          @apply flex flex-col gap-5;
          sup {
            @apply text-inherit text-xs -top-2.5;
          }
          p {
            @apply small text-white lg:large;
          }
        }

        &:nth-child(2) {
          @apply h-[--top-box-mob-h] lg:h-full lg:pr-[70px];
        }

        &:nth-child(3) {
          @apply h-[--bot-box-mob-h] lg:h-full lg:pl-[64px];
        }
      }
    }
  }

  &.mobile-reversed {
    .boxes,
    .bg-imgs {
      @apply flex-col-reverse lg:flex-row;
    }

    .floating-cta {
      &.cta-c {
        top: calc(var(--bot-box-mob-h) - 29px) !important;
      }
    }
  }
}
</style>
